<template>
  <MultipleChoicesDropdown
    title="Region"
    :value="value"
    :show-clear-all="false"
    :single-choice="singleChoice"
    :search-enabled="false"
    :choices="choices"
    @change="onChange"
  />
</template>

<script>
import { COUNTRIES_CHOICES } from 'services/countries'
import { REGIONS_CHOICES } from 'services/regions'

const allChoices = REGIONS_CHOICES

export default {
  props: {
    singleChoice: { type: Boolean, default: true },
    value: {},
  },
  computed: {
    choices: () => allChoices,
  },
  methods: {
    onChange(choices) {
      this.$emit('change', choices)
      // emit changeWithRegionsAndCountries
    },
  },
}
</script>
